import * as THREE from 'three'
import { MathUtils } from 'three'

import Experience from "./Experience"

export default class Raycast
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.camera = this.experience.camera

        this.objectsLoader = this.experience.objectsLoader
        this.currentPoint = new THREE.Vector3(0.0, 0.0, 0.0)

        this.particleObjects = this.experience.particleObjects
        this.particleObjects.on("ready", () => {this.init()})
        this.particleObjects.on("ready", () => {this.bindingEvents()})
    }

    bindingEvents()
    {
        document.addEventListener('mousemove', (event) => {this.mousemoveEvent(event)}, false)
    }

    mousemoveEvent(event)
    {
        event.preventDefault()

        this.pointer.x = (event.clientX / window.innerWidth) * 2.0 - 1.0
        this.pointer.y = -(event.clientY / window.innerHeight) * 2.0 + 1.0
    }

    update()
    {
        if (!this.isReady) return
        
        if (this.experience.sizes.widthState == 0)
        {
            let lerpX = MathUtils.lerp(this.pointerFollower.x, this.pointer.x, this.particleObjects.guiValues.mouseFollowerDelta)
            let lerpY = MathUtils.lerp(this.pointerFollower.y, this.pointer.y, this.particleObjects.guiValues.mouseFollowerDelta)
            this.pointerFollower = new THREE.Vector2(lerpX, lerpY)
        }
        else
        {
            let timeX = this.experience.time.timeFromBeginning
            let timeY = this.experience.time.timeFromBeginning * 0.5
            this.pointerFollower = new THREE.Vector2(Math.sin(timeX * 0.75) * 0.8, Math.sin(timeY * 0.75) * 0.8)
        }
        
        this.raycaster.setFromCamera(this.pointerFollower, this.camera.instance)
        this.scaleMultipleObjects()

        // OBJECT POSITION
        let resizeX = 0.0

        if (this.experience.sizes.widthState == 0)
        {
            if (this.experience.sizes.width >= 1200.0)
            {
                let widthPartial = 2.0 * 1200.0 / this.experience.sizes.width // 2.0 : width = x : 1200.0

                resizeX = widthPartial / 3.0 * -1.0
            }
            else
            {
                resizeX = 2.0 / 4.0 * -1.0
            }
        }

        this.raycasterResize.setFromCamera(new THREE.Vector2(resizeX, 0.0), this.camera.instance)
        this.intersectsResize = this.raycasterResize.intersectObjects(this.raycastResizeGroup)

        if (this.intersectsResize.length > 0)
        {
            this.currentPointResize = this.intersectsResize[0].point.clone()

            this.resize.position.set(this.currentPointResize.x, this.currentPointResize.y, this.currentPointResize.z)
        }
    }

    init()
    {
        this.pointer = new THREE.Vector2()
        this.pointerFollower = new THREE.Vector2()

        this.raycaster = new THREE.Raycaster()
        this.raycasterResize = new THREE.Raycaster()

        this.resize = new THREE.Mesh(new THREE.SphereGeometry(0.0, 16, 16))
        this.experience.scene.add(this.resize)
        this.raycastResizeGroup = [this.objectsLoader.items.Plane.mesh]

        this.raycastGroupMultiple = []
        this.raycastGroupSingle = []

        this.currentObject = null

        this.mouseFollower = new THREE.Mesh(new THREE.SphereGeometry(0.01, 4, 4), new THREE.MeshBasicMaterial())
        this.mouseFollower.scale.set(0.0, 0.0, 0.0)
        this.experience.scene.add(this.mouseFollower)

        this.isReady = true
    }

    scaleMultipleObjects()
    {
        if (this.particleObjects.state == 0) this.raycastGroupMultiple = [this.objectsLoader.items.Object_0.mesh, this.objectsLoader.items.Plane.mesh]
        else if (this.particleObjects.state == 2) this.raycastGroupMultiple = [this.objectsLoader.items.Object_1.mesh, this.objectsLoader.items.Plane.mesh]
        else if (this.particleObjects.state == 3) this.raycastGroupMultiple = [this.objectsLoader.items.Object_2.mesh, this.objectsLoader.items.Plane.mesh]
        else if (this.particleObjects.state == 5) this.raycastGroupMultiple = [this.objectsLoader.items.Object_3.mesh, this.objectsLoader.items.Plane.mesh]
        else this.raycastGroupMultiple = []

        this.intersects = this.raycaster.intersectObjects(this.raycastGroupMultiple)

        if (this.intersects.length > 0)
        {
            this.particleObjects.currentObjectRaycast = this.intersects[0].object
            this.currentPoint = this.intersects[0].point.clone()

            this.mouseFollower.position.set(this.currentPoint.x, this.currentPoint.y, this.currentPoint.z)

            this.particleObjects.dynamicParticleMaterial.uniforms.worldPointer.value = this.currentPoint
        }

        for (let i = 0; i < this.particleObjects.particles.children.length; i++)
        {
            if (this.intersects.length > 0)
            {
                let currentWorldPosition = new THREE.Vector3()

                this.particleObjects.particles.children[i].getWorldPosition(currentWorldPosition)
                    
                let distanceFromMouse = currentWorldPosition.distanceToSquared(this.currentPoint)
                    
                this.particleObjects.particles.children[i].onHover = distanceFromMouse <= this.particleObjects.guiValues.mouseRadiusMagnet * 0.1
                this.particleObjects.particles.children[i].distanceFromMouse = distanceFromMouse

                let distanceFromProxyMouse = currentWorldPosition.distanceToSquared(this.camera.proxyMouse.localToWorld(this.camera.proxyMouse.position.clone()))
            
                this.particleObjects.particles.children[i].onHoverProxy = distanceFromProxyMouse <= this.particleObjects.guiValues.proxyMouseRadius * 0.1
                this.particleObjects.particles.children[i].distanceFromProxyMouse = distanceFromProxyMouse
            }
            else
            {
                this.particleObjects.currentObject = null
                
                this.particleObjects.particles.children[i].onHover = false
                this.particleObjects.particles.children[i].onHoverProxy = false
            }
        }
    }

    setShowMouseFollower(value)
    {
        if (value) this.mouseFollower.scale.set(1.0, 1.0, 1.0)
        else this.mouseFollower.scale.set(0.0, 0.0, 0.0)
    }
}